import React, { Component } from 'react';
import { Button, Col, Container, Row } from 'reactstrap';
import { Redirect } from 'react-router-dom';

import { LogoHeader } from '../../../containers/Components/index'

import instagram_square from '../../../assets/img/instagram-square.png';


class AppGuide extends Component {
  constructor(props) {
    super(props);
    this.state = {
      login: false,
      signup: false,
      warning: "",
      showVerify: false,
      html_btn_status: 0,
    };
    this.user_name = "";
    this.pwd = "";
  }

  renderRedirect = () => {
    if (this.state.login) {
      return <Redirect to= { '/login/'} />
    }
    if (this.state.signup) {
      return <Redirect to= { '/register/'} />
    }
  }
  render() {

    // let slider_count = 4;
    // if (window.innerWidth < 520) {
    //   slider_count = 4;
    // }

    return (
      <div className="app flex-row font-Poppins">
      {this.renderRedirect()}
        <React.Fragment>
        <LogoHeader />
        
        <div className="app-body p-0 m-0 width-100vw mt-5 ">
            <Container className = "background-white" fluid>
               <Row className = "about_page_gradient mt-3 ">
                 <Col className = "d-md-down-none" xs="6" sm="6" lg="2">
                 </Col>
                 <Col xs="6" sm="6" lg="2">
                  <h5 className = "m-3 text-white"> Solutions </h5>
                 </Col>
                </Row>
                <Row>
                  <Col className = "d-md-down-none" xs="6" sm="6" lg="2">
                  </Col>
                  <Col xs="12" sm="12" lg="8">
                    <h6 className = "mt-4 line-height-h">
                      <b>Classroom Learning</b>
                      <br></br>
                      Our groundbreaking technology is designed to help raise engagement & increase knowledge retention 
                      for students of all ages. We have everything your school needs.
                    </h6>
                    <h6 className = "mt-4 line-height-h">
                      <b>Business Communication Training</b>
                      <br></br>
                      With 67 percent of recruiters withholding offers due to a lack of soft skills, organizations must 
                      rethink their approach to soft-skills training. VR setups can help recreate common workplace scenarios 
                      and let employees practice their reactions and handling of these situations.
                    </h6>
                    <h6 className = "mt-4 line-height-h">
                      <b>Corporate Training</b>
                      <br></br>
                      Corporate training is all about the balance between gaining knowledge and building experience – 
                      learning through practice. The ability to go back through scenarios again and again, without additional 
                      expense or inconvenience, is a great advantage. VR is particularly powerful in this context.
                    </h6>
                    <h6 className = "mt-4 line-height-h">
                      <b>High-end retail product showcase</b>
                      <br></br>
                      For consumers who are short on time but not on cash, AR offers the opportunity to try on luxury items 
                      wherever and whenever they like without worrying about the brand’s retail locations or operating hours. 
                      By enhancing the online shopping experience, AR plays an important role in increasing desire and 
                      facilitating choice; perhaps to such a degree that it prompts the consumer to visit the store in-person 
                      and make a purchase.
                    </h6>
                    <h6 className = "mt-4 line-height-h">
                      <b>High-end home or office decor showcase</b>
                      <br></br>
                      Home decor is a dream for every individual and everyone wants the dwelling to be beautifully decorated. 
                      Furniture is the keyword in home decor as it’s the major part every individual has to deal with. 
                      AR is enabling everyone to have a much clear understanding of products, without even watching them 
                      in reality. AR 3D views help in convincing buyers about the furniture structure and help in increasing 
                      sales. The AR catalog can be more attractive and convincing as compared to any 2D catalogs.
                    </h6>
                    <h6 className = "mt-4 line-height-h">
                      <b>Industry 4.0 applications</b>
                      <br></br>
                      Industry 4.0 generally refers to implementation of Artificial Intelligence, Big Data, Augmented Reality, 
                      and the Industrial Internet of Things (IIoT) in factories. Companies are constantly looking for innovative 
                      solutions to improve the production process and make it more efficient and user-friendly, and MR presents 
                      numerous opportunities.
                    </h6>
                  </Col>  
                  <Col className = "d-md-down-none" xs="6" sm="6" lg="2">
                  </Col>
                </Row>
{/* -------------- Footer Start -------- */}
                <Row className="mt-5">
                </Row>
                <Row className="pt-5 pb-5 home-background-gray">
                  <Col xs="0" sm="0" lg="1">
                  </Col>
                  <Col xs="4" sm="4" lg="2">
                    <Row className = "ml-2 text-left">
                      <Col className="mt-5 mb-4" md = '12'> 
                        <div>PRODUCT</div>
                      </Col>
                      <Col className="mb-2 text-secondary" md = '12'> 
                         <a href = "/feature"><div className = "font-size-10" >Features & Roadmap</div></a>
                      </Col>
                      <Col className="mb-2 text-secondary" md = '12'> 
                        <a href = "/appguide"><div className = "font-size-10" >Solutions</div></a>
                      </Col>
                      <Col className = "mb-2 text-secondary"  md = '12'> 
                        <a href = "/customdev"><div className = "font-size-10" >Professional Services</div></a>
                      </Col>
                      <Col className = "mb-2 text-secondary"  md = '12'> 
                        <a href = "/pricing"><div className = "font-size-10" >Pricing</div></a>
                      </Col>
                    </Row>
                  </Col>
                  <Col xs="4" sm="4" lg="2">
                    <Row className = "text-left ml-2">
                      <Col className="mt-5 mb-4" md = '12'> 
                        <div >USE CASES</div>
                      </Col>
                      <Col className = "mb-2 text-secondary" md = '12'> 
                        <a href = "/education"><div className = "font-size-10" >Education</div></a>
                      </Col>
                      <Col className = "mb-2 text-secondary" md = '12'> 
                        <a href = "/training"><div className = "font-size-10" >Training</div></a>
                      </Col>
                      <Col className = "mb-2 text-secondary" md = '12'> 
                        <a href = "/retail"><div className = "font-size-10" >Retail</div></a>
                      </Col>
                      <Col className = "mb-2 text-secondary" md = '12'> 
                        <a href = "/ecommerce"><div className = "font-size-10" >Ecommerce</div></a>
                      </Col>
                    </Row>
                  </Col>
                  <Col xs="4" sm="4" lg="2">
                    <Row className = "text-left ml-2">
                      <Col className="mt-5 mb-4" md = '12'> 
                        <div>Support</div>
                      </Col>
                      <Col className="mb-2 text-secondary" md = '12'> 
                        <a href = "http://www.icomputinglabs.in/blog/" target="_blank" rel="noopener noreferrer">
                        <div className = "font-size-10" >Blog</div> </a>
                      </Col>
                      <Col className="mb-2 text-secondary" md = '12'> 
                        <a href = "/faq"><div className = "font-size-10" >FAQ</div></a>
                      </Col>
                      <Col className = "mb-2 text-secondary" md = '12'> 
                        <a href = "/contact"><div className = "font-size-10" >Contact</div></a>
                      </Col>
                    </Row>
                  </Col>
                  <Col xs="6" sm="6" lg="2">
                    <Row className = "text-left ml-2">
                      <Col className="mt-5 mb-4" md = '12'> 
                        <div>COMPANY</div>
                      </Col>
                      <Col className="mb-2 text-secondary" md = '12'> 
                        <a href = "/about"><div className = "font-size-10" >About</div></a>
                      </Col>
                      <Col className="mb-2 text-secondary" md = '12'> 
                        <a href = "/privacy"><div className = "font-size-10" >Privacy Policy</div></a>
                      </Col>
                      <Col className = "mb-2 text-secondary" md = '12'> 
                        <a href = "/tos"><div className = "font-size-10" >Terms of Service</div></a>
                      </Col>
                    </Row>
                  </Col>
                  <Col xs="6" sm="6" lg="2">
                    <Row className = "text-left ml-2">
                      <Col className="mt-5 mb-4" md = '12'> 
                        <div>GET CONNECTED</div>
                      </Col>
                      <Col className="mb-2 text-secondary" md = '12'> 
                        <a href = "https://www.facebook.com/icomputinglabs/" target="_blank" rel="noopener noreferrer">
                        <div className = "font-size-10" ><i className = "text-primary fa fa-facebook-square fa-lg mr-2" />facebook</div>
                        </a>
                      </Col>
                      <Col className="mb-2 text-secondary" md = '12'> 
                        <a href = "https://www.instagram.com/icomputinglabs/" target="_blank" rel="noopener noreferrer">
                        <div className = "font-size-10" ><img  alt="" src={instagram_square} className = "text-primary width-16 mr-2" />instagram</div>
                        </a>
                      </Col>
                      <Col className = "mb-2 text-secondary"  md = '12'> 
                        <a href = "https://twitter.com/iComputingLabs" target="_blank" rel="noopener noreferrer">
                        <div className = "font-size-10" ><i className = "text-primary fa fa-twitter-square fa-lg mr-2" />twitter</div>
                        </a>
                      </Col>
                      <Col className = "mb-2 text-secondary"  md = '12'>
                        <a href = "https://www.linkedin.com/company/13404850/" target="_blank" rel="noopener noreferrer">
                        <div className = "font-size-10" ><i className = "text-primary fa fa-linkedin-square fa-lg mr-2" />linkedin</div>
                        </a>
                      </Col>
                    </Row>
                  </Col>
                </Row>
              {/* -------------- Footer End -------- */}
  
            </Container>
        </div>
        </React.Fragment>
      </div>
    );
  }
}

export default AppGuide;



// WEBPACK FOOTER //
// ./src/views/Pages/AppGuide/AppGuide.js